import { SUSPENSE_COMPETITOR, SUSPENSE_REASON } from '../../../../../../views/billing/subscription/constants';

export default {
  title: 'Facturación automática',
  buttons: {
    add_subscription: 'Añadir suscripción',
    suspend_company: 'Suspender restaurante',
    restore_company: 'Restaurar restaurante',
    edit_suspend: 'Editar información de suspensión',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
  },
  modals: {
    suspend_company: {
      title: '¿Seguro que deseas suspender {{company}}?',
      description:
        'Esto cancelará todas las suscripciones activas, desactivará los pedidos en vivo y notificará al propietario del restaurante por correo electrónico. Selecciona un motivo antes de confirmar.',
      suspense_reason: {
        label: 'Selecciona el motivo de la suspensión',
        placeholder: 'Elige un motivo',
        options: {
          [SUSPENSE_REASON.ClosedOrOwnershipChange]: 'Cierre o cambio de propietario',
          [SUSPENSE_REASON.LowRoi]: 'ROI bajo',
          [SUSPENSE_REASON.PricingFeesSensitivity]: 'Sensibilidad a precios/tarifas',
          [SUSPENSE_REASON.MissingIntegrationsProductGaps]: 'Integraciones faltantes/brechas de producto',
          [SUSPENSE_REASON.PoorOnboardingActivation]: 'Incorporación/activación deficiente',
          [SUSPENSE_REASON.SupportDissatisfaction]: 'Insatisfacción con el soporte',
          [SUSPENSE_REASON.SwitchedToCompetitor]: 'Cambio a competidor/marketplace/solución propia',
          [SUSPENSE_REASON.MarketingPerformanceDisappointment]: 'Decepción con el rendimiento de marketing',
          [SUSPENSE_REASON.WrongRegistrationData]: 'Registro/datos incorrectos',
        },
        validation: {
          required: 'Por favor, elige un motivo',
        },
      },
      suspense_competitor: {
        label: '¿A qué competidor se cambiaron?',
        placeholder: 'Por favor, elige un competidor',
        options: {
          [SUSPENSE_COMPETITOR.Allo]: 'Allo',
          [SUSPENSE_COMPETITOR.Sides]: 'Slice',
          [SUSPENSE_COMPETITOR.Ordersmart]: 'Ordersmart',
          [SUSPENSE_COMPETITOR.RobinCook]: 'Robin Cook',
          [SUSPENSE_COMPETITOR.Lightspeed]: 'Lightspeed',
          [SUSPENSE_COMPETITOR.GastroMaster]: 'Gastro Master',
          [SUSPENSE_COMPETITOR.Dish]: 'Dish',
          [SUSPENSE_COMPETITOR.Other]: 'Otro',
        },
        validation: {
          required: 'Por favor, elige un competidor',
        },
      },
      suspense_reason_notes: {
        label: 'Contexto adicional (opcional)',
        placeholder: 'Añade cualquier detalle adicional',
      },
    },
    restore_company: {
      title: '¿Seguro que deseas restaurar {{company}}?',
      description: 'Aún tendrás que crear la suscripción y habilitar los pedidos en vivo manualmente.',
    },
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los detalles de la suscripción',
    failed_to_suspend_company: 'Error al suspender el restaurante. Contacta con soporte técnico',
    failed_to_restore_company: 'Error al restaurar el restaurante. Contacta con soporte técnico',
  },
};
